import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=732040f4&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('732040f4')) {
      api.createRecord('732040f4', component.options)
    } else {
      api.reload('732040f4', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=732040f4&", function () {
      api.rerender('732040f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/weeklylogin/campaign/Index.vue"
export default component.exports